import PropTypes from 'prop-types'

const MAX_ESTRELLAS = 5
const Opiniones = ({ calificacion, comentario }) => {
  const estrellas = (
    <div className="col-2">
      {Array.from({ length: MAX_ESTRELLAS }).map((_, i) => (
        <i
          key={i}
          className={`fa ${i < calificacion ? 'fa-star' : 'fa-star-o'} yellow-star`}
          aria-hidden="true"
        ></i>
      ))}
    </div>
  )

  return (
    <>
      <div className="row mt-3">
        {estrellas}
        <div className="col">{comentario}</div>
      </div>
      <hr className="hr" />
    </>
  )
}

Opiniones.propTypes = {
  calificacion: PropTypes.number.isRequired,
  comentario: PropTypes.string.isRequired
}

export default Opiniones
